export default {"src":"/_next/static/media/dashboard.3cb2ceb7.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};